/**
 * File swup.js
 * https://swup.js.org/getting-started/
 */

import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupJsPlugin from '@swup/js-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {initAnimations} from './animations';
import {initLightbox} from './lightbox';
import {initNavigation} from './navigation';

(function() {

    initAnimations();
    initLightbox();
    initNavigation();

    document.querySelectorAll('#wpadminbar').forEach(item => {
        item.setAttribute('data-no-swup', '');
    });

    const loader = document.querySelector('.page-loader');
    gsap.set(loader, {
        scaleX: 0,
        rotation: 10,
        xPercent: -5,
        yPercent: -50,
        transformOrigin: 'left center',
        autoAlpha: 1,
    });

    const SwupBody = new SwupBodyClassPlugin();
    const SwupHead = new SwupHeadPlugin({
        persistTags: 'style#cky-style',
    });
    const SwupPreload = new SwupPreloadPlugin();
    const SwupScroll = new SwupScrollPlugin({
        offset: 70,
    });
    const SwupJs = new SwupJsPlugin({
        animations: [
            {
                from: '(.*)',
                to: '(.*)',
                out: async () => {
                    return gsap.fromTo(loader,
                        {
                            rotation: 10,
                            scaleX: 0,
                            xPercent: -5,
                        },
                        {
                            duration: .5,
                            xPercent: 0,
                            scaleX: 1,
                            rotation: 0,
                            ease: 'Power4.inOut',
                            transformOrigin: 'left center',
                        });
                },
                in: async () => {
                    window.scrollTo(0, 0);
                    gsap.to(loader, {
                        duration: .5,
                        scaleX: 0,
                        xPercent: 5,
                        rotation: -10,
                        transformOrigin: 'right center',
                        ease: 'power4.inOut',
                    });
                }
            }
        ]
    });

    const swup = new Swup({
        containers: ["[data-swup]"],
        plugins: [
            SwupBody,
            SwupHead,
            SwupPreload,
            SwupJs,
            SwupScroll,
        ]
    });

    const resetVideos = () => {
        document.querySelectorAll('video[autoplay]').forEach((video) => {
            video.play();
        });
    }

    swup.hooks.on('page:view', (visit) => {
        if ( !visit.to.url.includes(klark.api_url) && !visit.from.url.includes(klark.api_url) ) {
            ScrollTrigger.getAll().forEach((x) => x.kill());
            ScrollTrigger.refresh();
            initLightbox();
            initNavigation();
            initAnimations();
            resetVideos();

            window.dispatchEvent(new Event('resize'));
            document.querySelectorAll('#wpadminbar').forEach(item => {
                item.setAttribute('data-no-swup', '');
            });
        }
    });
})();